import { $ } from '@/Engine/state';

export const onNoWallIntersection = () => {
    $.wardrobe.removeModuleByUUID('temp');
    $.removeDoorByUUID('temp');
    $.removeWindowsByUUID('temp');
    $.tempShelf = null;
};